
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/docs/atlas/troubleshooting",
      function () {
        return require("private-next-pages/docs/atlas/troubleshooting.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/docs/atlas/troubleshooting"])
      });
    }
  